module.exports = __webpack_public_path__ + "static/media/Sova_(Full).c99b1934.png";